import httpClient from './httpClient'

const END_POINT = '/api/get-nivel'

const getNivel = (idAlumno,idIdioma,edad,idLocalizacion) => httpClient.get(END_POINT, { params: { idAlumno: idAlumno, idIdioma: idIdioma, edad: edad, idLocalizacion: idLocalizacion  } } )

export {

    getNivel

}